var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 2V6.44444M19.071 4.92893L15.9283 8.07163M22 12.0002H17.5555M19.071 19.071L15.9283 15.9283M11.9999 17.5556V22M8.07154 15.9284L4.92883 19.0711M6.44446 12.0002H2",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLoader);
export default __webpack_public_path__ + "static/media/btn_loader.56a5a8d2f854e8de90725455232ed62f.svg";
export { ForwardRef as ReactComponent };